import { Context } from 'react';
import { ClusteredDataContextType } from '../Providers/clusteredData';
import { ZoomContext } from '../Providers/d3Zoomable';
import { HotSpotItem } from '../Providers/dataContext';

type ZoomContextType = typeof ZoomContext extends Context<infer T> ? T : never;

function scaleAndCenterOnDataPoint<T extends HotSpotItem>(
   datapointId: string,
   clusteredDataContext: ClusteredDataContextType<T>,
   zoomContext: ZoomContextType
) {
   const datapoint = clusteredDataContext.getDatapointById(datapointId);

   if (!datapoint) {
      return;
   }

   const cluster = clusteredDataContext.getClusterById(datapointId);
   if (!cluster) {
      return;
   }

   const zoomFactor =
      cluster.length > 1 ? clusteredDataContext.getFullDeclusterZoomFactor(cluster) : 1;

   const newZoomFactor = zoomContext.d3Transform.k * zoomFactor;
   const newX = datapoint.x * newZoomFactor;
   const newY = datapoint.y * newZoomFactor;

   return new Promise(resolve => {
      zoomContext.scaleAndCenterOn(newX, newY, newZoomFactor, resolve as () => void);
   });
}

export { scaleAndCenterOnDataPoint };
